module.exports = __webpack_public_path__ + "static/media/loader.e59daf55.gif";